// Default time format constants
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
// cspell:ignore ssxxxxx
export const DATE_WITH_TIMEZONE_FORMAT = "yyy-MM-dd'T'HH:mm:ssxxxxx";
export const DEFAULT_DATE_LOCALE = 'en-US';
